import { REQUEST_STATUS, APPROVAL_STATUS } from './general';

export function createUserObject(userId, firstName, lastName, email) {
    return {
        userId,
        userName: {
            firstName,
            lastName
        },
        email
    }
}


export function createNewMessage(user, text, date) {
    return {
        user,
        text,
        date
    }
}

export function createNewRequest(userId, advocateId, justification, bookInfo) {
    return {
        requestInfo: {
            requestId:  `${Math.floor(Math.random()*(1000000000000-10000+1)+1000)}`,  // TODO: REALLY BAD IDEA
            userId,
            advocateId,
            advocateApproval: APPROVAL_STATUS.pending,
            resourceApproval: APPROVAL_STATUS.pending,
            requestStatus: REQUEST_STATUS.awaitingApproval,
            requestDate: new Date(),
            justification,
            messages: []
        },
        bookInfo
    };
}



/** WEBPACK FOOTER **
 ** ./src/constants/factory.js
 **/